module.exports = __webpack_public_path__ + "img/YCV2001.8ec93fd5.png";